(function(){
    let emergencyNotificationClass = "emergency-notification-container";
    let emergencyNotificationHiddenClass = "emergency-notification-container-hidden";
    let notificationhideButtonClass = "emergency-notification-hide-button";
    let notificationCookie = "emergency-notification-seen";

    function setCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    function hideNotification() {
        notifications = document.getElementsByClassName(emergencyNotificationClass);
        if (notifications && notifications.length) {
            notifications[0].classList.add(emergencyNotificationHiddenClass);
        }
    }

    function showNotification() {
        notifications = document.getElementsByClassName(emergencyNotificationClass);
        if (notifications && notifications.length) {
            notifications[0].classList.remove(emergencyNotificationHiddenClass);
        }
    }

    function onNotificationHideClicked() {
        hideNotification();
        setCookie(notificationCookie, true);
    }
    document.addEventListener("DOMContentLoaded",
        function () {
            notifications = document.getElementsByClassName(emergencyNotificationClass);
            if (notifications && notifications.length > 0) {
                let cookieValue = getCookie(notificationCookie);
                if (cookieValue) {
                    hideNotification();
                }
                else {
                    let hideButtons = document.getElementsByClassName(notificationhideButtonClass);
                    hideButtons[0].addEventListener('click', onNotificationHideClicked);
                }
            }
        }
    );
    showNotification();
})();